import classNames from 'classnames';

export interface PageDetailHeaderProps {
  className?: string;
  align?: 'left' | 'center' | 'right';
}

export function PageDetailHeader({
  children,
  className,
  align = 'center',
}: React.PropsWithChildren<PageDetailHeaderProps>) {
  return (
    <header className={classNames(className, 'bg-background text-white pb-10')}>
      <div
        className={classNames(
          'px-4 pb-4 pt-2',
          align === 'left' && 'mr-auto',
          align === 'center' && 'mx-auto',
          align === 'right' && 'ml-auto',
        )}
      >
        {children}
      </div>
    </header>
  );
}

export default PageDetailHeader;
